export function extractErrorDetails(error) {
    const err = error;
    return {
        message: err?.message || String(error),
        name: err?.name,
        stack: err?.stack,
        status: err?.response?.status,
        statusText: err?.response?.statusText,
        responseData: err?.response?.data,
        requestUrl: err?.request?.url,
        code: err?.code,
    };
}
